import { useCustomMutation } from '@refinedev/core';
import { Modal, Input, InputNumber, message } from 'antd';
import { useState, type FC } from 'react';

interface RefundModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const RefundModal: FC<RefundModalProps> = ({ open, onClose, onSuccess }) => {
  const { mutate, isLoading } = useCustomMutation();
  const [form, setForm] = useState({
    subscriptionId: '',
    reason: '',
    amount: 0,
    currency: 'eur',
  });

  const handleSubmit = () => {
    if (!form.subscriptionId) {
      void message.warning('Veuillez renseigner l\'ID abonnement');
      return;
    }

    mutate(
      {
        url: '/api/v1/admin/billing/refund',
        method: 'post',
        values: {
          subscriptionId: form.subscriptionId,
          reason: form.reason,
          amount: form.amount > 0 ? form.amount : undefined,
        },
      },
      {
        onSuccess: () => {
          void message.success('Remboursement initie');
          setForm({ subscriptionId: '', reason: '', amount: 0, currency: 'eur' });
          onSuccess();
        },
        onError: () => {
          void message.error('Erreur lors du remboursement');
        },
      },
    );
  };

  return (
    <Modal
      title="Effectuer un remboursement"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={isLoading}
      okText="Rembourser"
      cancelText="Annuler"
      destroyOnClose
    >
      <div className="space-y-4 pt-2">
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">
            ID Abonnement
          </label>
          <Input
            value={form.subscriptionId}
            onChange={(e) => setForm((f) => ({ ...f, subscriptionId: e.target.value }))}
            placeholder="sub_xxx ou UUID"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">
            Montant (centimes, 0 = total)
          </label>
          <InputNumber
            className="w-full"
            min={0}
            value={form.amount}
            onChange={(v) => setForm((f) => ({ ...f, amount: v ?? 0 }))}
            placeholder="0 = remboursement total"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-300">
            Raison
          </label>
          <Input.TextArea
            rows={3}
            value={form.reason}
            onChange={(e) => setForm((f) => ({ ...f, reason: e.target.value }))}
            placeholder="Raison du remboursement..."
          />
        </div>
      </div>
    </Modal>
  );
};

export default RefundModal;
